import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import Reservations from '../../relationship/partials/Reservations'

//images
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function ReservationsModal(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        partnerId: null,
    })

    useImperativeHandle(ref, () => ({
        open: (id) => {
            setPopup(prev => ({
                ...prev,
                partnerId: id
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                partnerId: null,
            }))
        }, 50)
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <div className={`${popup.modal ? 'show' : ''} popup-primary ultra-large`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.unpaidReservations')}
                        </h2>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="popup-container">
                    <div style={{ width: '100%' }}>
                        {popup.overlay && popup.partnerId &&
                            <Reservations
                                relatedPartnerId={popup.partnerId}
                                refreshData={props.refreshData}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(ReservationsModal)
